import React from 'react';
import { useField } from 'formik';

import { TextArea } from '../shared/TextArea/TextArea';

export const FormikTextArea = ({ name, leftIcon, required, ...props }) => {
  const [field, meta] = useField(name);

  return (
    <TextArea
      {...field}
      {...props}
      name={name}
      leftIcon={leftIcon}
      isRequired={required}
      error={meta.touched && meta.error ? meta.error : undefined}
    />
  );
};
